"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.metadataEditorModal = void 0;
var ActionTypes = require("actionTypes/metadataEditor");
var TypeLib = require("@caddigital/sok-types");
var moment = require("moment");
var initialState = {
    status: 'STANDBY',
    type: 'REVISION_OR_FOLDER',
    fileUuids: [],
    isExportable: false,
    timesSaved: 0,
    lastSaved: undefined,
    hasPreviousRevisions: false,
    files: [],
    path: [],
    idxLookup: {},
    colIdxLookup: {},
    requiredCols: {},
    dirtyRows: {},
    errRows: {},
    dirtyColumns: [],
    failedColumns: [],
    errorRows: []
};
var deserializeValue = function (type) { return function (value) {
    if (type === 'day' && value && typeof value === 'number') {
        return moment(value);
    }
    if (type === 'datetime' && value && typeof value === 'number') {
        return moment(value);
    }
    return value;
}; };
var serializeValue = function (type) { return function (value) {
    if ((type === 'day' || type === 'datetime') &&
        value !== null &&
        typeof value === 'object') {
        return value.unix() * 1000;
    }
    return value;
}; };
var metadataEditorModal = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case ActionTypes.FETCH_METADATA_EDITOR_HIERARCHY_REQUEST: {
            if (action.hierarchyType === 'SESSION') {
                return __assign(__assign({}, initialState), { status: 'FETCHING', type: action.hierarchyType, sessionUuid: action.uuid[0], isExportable: false });
            }
            return __assign(__assign({}, initialState), { status: 'FETCHING', type: action.hierarchyType, fileUuids: action.uuid, isExportable: true });
        }
        case ActionTypes.FETCH_METADATA_EDITOR_HIERARCHY_FAILURE: {
            return __assign(__assign({}, initialState), { status: 'ERROR' });
        }
        case ActionTypes.FETCH_METADATA_EDITOR_HIERARCHY_SUCCESS: {
            var _a = action.data, list = _a.list, path = _a.path;
            var files = list;
            var lookup = {};
            var colIdxLookup = {};
            var requiredCols_1 = {};
            var hasPreviousRevisions = false;
            for (var i = 0; i < files.length; i++) {
                var row = files[i];
                if (i === 0) {
                    row.customMeta &&
                        row.customMeta
                            .filter(function (c) { return c.identifier !== 'name-meta'; })
                            .reduce(function (map, item, idx) {
                            map[item.identifier] = idx;
                            // Update required columns
                            if (item.required === true &&
                                (item.bitField & TypeLib.CustomMeta.FILES_LIST) > 0) {
                                requiredCols_1[item.identifier] = true;
                            }
                            return map;
                        }, colIdxLookup);
                }
                // Field formatting for ui
                row.customMeta &&
                    row.customMeta.forEach(function (meta, idx) {
                        var formattedValue;
                        if (meta.type === 'dependant-select' ||
                            meta.type === 'select' ||
                            meta.type === 'radio') {
                            var option = meta.options &&
                                meta.options.find(function (o) { return o.name === meta.value; });
                            if (option) {
                                formattedValue = option.value;
                            }
                        }
                        else {
                            formattedValue = deserializeValue(meta.type)(meta.value);
                        }
                        meta.formattedValue = formattedValue;
                        meta.hasError = false;
                    });
                if (row.type !== 'FOLDER' && row.version > 1) {
                    hasPreviousRevisions = true;
                }
            }
            var parents = {};
            var parentLookup_1 = {};
            for (var i = files.length - 1; i >= 0; i--) {
                var file = files[i];
                if (!file || !file.customMeta) {
                    continue;
                }
                var metas = file.customMeta.findIndex(function (x) { return x.uuid === 'size-meta'; });
                if (file.type === 'FOLDER') {
                    if (file.path)
                        parentLookup_1[file.id] = file.path;
                    parents[file.parent] =
                        (parents[file.parent] || 0) + (parents[file.id] || 0);
                    if (file.customMeta && file.customMeta[metas]) {
                        file.customMeta[metas].value = parents[file.id] || 0;
                        file.customMeta[metas].formattedValue =
                            parents[file.id] || 0;
                    }
                }
                else {
                    parents[file.parent] =
                        (parents[file.parent] || 0) +
                            (metas > -1
                                ? +(file.customMeta[metas].value
                                    ? file.customMeta[metas].value
                                    : 0)
                                : 0);
                }
            }
            var revisions_1 = files
                .filter(function (f) { return f.type !== 'FOLDER'; })
                .reduce(function (p, c) {
                if (!p[c.parent]) {
                    p[c.parent] = [];
                }
                p[c.parent].push(c);
                return p;
            }, {});
            var folders = files
                .filter(function (f) { return f.type === 'FOLDER'; })
                .map(function (f) {
                if (!parentLookup_1[f.parent]) {
                    f.parent = 0;
                }
                return f;
            })
                .sort(function (c, p) {
                if (!c.path || !p.path)
                    return 0;
                if (c.parent === 0 && p.parent === 0) {
                    return c.path
                        .replace(/.$/, '')
                        .localeCompare(p.path.replace(/.$/, ''));
                }
                if (p.id === c.parent)
                    return +1;
                return c.path.localeCompare(p.path);
            });
            var sorted = folders.reduce(function (p, c) {
                p.push(c);
                if (!revisions_1[c.id])
                    return p;
                var arr = p.concat(revisions_1[c.id].sort(function (c, p) {
                    if (!c.path || !p.path)
                        return 0;
                    return c.path.localeCompare(p.path);
                }));
                delete revisions_1[c.id];
                return arr;
            }, []);
            var revs = Object.keys(revisions_1)
                .reduce(function (a, c) { return a.concat(revisions_1[c]); }, [])
                .sort(function (c, p) {
                if (!c.path || !p.path)
                    return 0;
                return c.path.localeCompare(p.path);
            });
            var sortedFiles = sorted.concat(revs);
            for (var i = 0; i < sortedFiles.length; i++) {
                lookup[sortedFiles[i].uuid] = i;
            }
            return __assign(__assign({}, state), { status: 'FETCHED', hasPreviousRevisions: hasPreviousRevisions, files: sorted.concat(revs), idxLookup: lookup, colIdxLookup: colIdxLookup, requiredCols: requiredCols_1, path: path });
        }
        case ActionTypes.IMPORT_METADATA_REQUEST: {
            return __assign(__assign({}, state), { status: 'IMPORTING' });
        }
        case ActionTypes.IMPORT_METADATA_SUCCESS: {
            return __assign(__assign({}, state), { status: action.isValid
                    ? 'IMPORTING_SUCCESS'
                    : 'IMPORTING_SUCCESS_WITH_INVALID_DATA' });
        }
        case ActionTypes.IMPORT_METADATA_FAILURE: {
            return __assign(__assign({}, state), { status: 'IMPORTING_ERROR' });
        }
        case ActionTypes.EDIT_METADATA_ROW: {
            var uuid = action.uuid, field = action.field;
            var dirtyColumns = state.dirtyColumns.slice(0);
            var idx = state.idxLookup[uuid];
            var row = state.files[idx];
            if (!row || !row.customMeta) {
                return state;
            }
            if (row.customMeta[field.key].value === field.value) {
                return state;
            }
            var cm = row.customMeta[field.key]; // force any type to store formattedValue info
            if (!cm) {
                return state;
            }
            cm.value = serializeValue(cm.type)(field.value);
            cm.formattedValue = deserializeValue(cm.type)(field.value);
            state.files[state.idxLookup[uuid]] = row;
            cm.row = uuid;
            dirtyColumns.push(cm);
            var dirtyRows = {};
            dirtyRows[uuid] = {};
            dirtyRows[uuid][field.key] = field.value;
            return __assign(__assign({}, state), { files: state.files, dirtyColumns: dirtyColumns, dirtyRows: dirtyRows });
        }
        case ActionTypes.BATCH_EDIT_METADATA_ROW: {
            var dirtyColumns_1 = state.dirtyColumns.slice(0);
            var dirtyRows_1 = {};
            var _loop_1 = function (i) {
                var rowItem = action.rows[i];
                var uuid = rowItem.uuid;
                var fields = rowItem.values;
                var idx = state.idxLookup[uuid];
                var row = state.files[idx];
                var customMeta = row.customMeta;
                if (!row || !customMeta || !fields) {
                    return "continue";
                }
                dirtyRows_1[uuid] = {};
                Object.keys(fields).forEach(function (key, index) {
                    var value = fields[key];
                    var cm = customMeta.find(function (c) { return c.uuid === key; });
                    if (!cm) {
                        return state;
                    }
                    cm.value = value !== null ? serializeValue(cm.type)(value) : null;
                    cm.formattedValue =
                        value !== null ? deserializeValue(cm.type)(value) : null;
                    state.files[state.idxLookup[uuid]] = row;
                    cm.row = uuid;
                    dirtyColumns_1.push(cm);
                    dirtyRows_1[uuid][key] = value; // (value ? value.toString() : null) as string
                });
            };
            for (var i = 0; i < action.rows.length; i++) {
                _loop_1(i);
            }
            return __assign(__assign({}, state), { files: state.files, dirtyColumns: dirtyColumns_1, dirtyRows: dirtyRows_1 });
        }
        case ActionTypes.OVERRIDE_COLUMNS: {
            var field = action.field;
            var dirtyRows = {};
            var dirtyColumns = state.dirtyColumns.slice(0);
            for (var i = 0; i < state.files.length; i++) {
                var file = state.files[i];
                if (!file.customMeta) {
                    continue;
                }
                var column = file.customMeta[state.colIdxLookup[field.key] + 1];
                if (column) {
                    column.value = serializeValue(column.type)(field.value);
                    column.formattedValue = deserializeValue(column.type)(field.value);
                    column.row = file.uuid;
                    dirtyColumns.push(column);
                    dirtyRows[file.uuid] = {};
                    dirtyRows[file.uuid][field.key] = field.value;
                }
            }
            return __assign(__assign({}, state), { files: state.files, dirtyColumns: dirtyColumns, dirtyRows: dirtyRows });
        }
        case ActionTypes.VALIDATE_METADATA_EDITOR_FAILURE: {
            return __assign(__assign({}, state), { status: 'VALIDATION_ERROR', failedColumns: action.columns, errorRows: action.rows, errRows: action.errRows });
        }
        case ActionTypes.VALIDATE_METADATA_EDITOR_SUCCESS: {
            return __assign(__assign({}, state), { failedColumns: [], errRows: {}, errorRows: [] });
        }
        case ActionTypes.SAVE_METADATA_EDITOR_REQUEST: {
            return __assign(__assign({}, state), { status: 'SAVING' });
        }
        case ActionTypes.SAVE_METADATA_EDITOR_FAILURE: {
            return __assign(__assign({}, state), { status: 'VALIDATION_ERROR' });
        }
        case ActionTypes.SAVE_METADATA_EDITOR_SUCCESS: {
            return __assign(__assign({}, state), { status: 'SAVED', timesSaved: state.timesSaved + 1, lastSaved: new Date(), dirtyRows: {}, dirtyColumns: [] });
        }
        default:
            return state;
    }
};
exports.metadataEditorModal = metadataEditorModal;
